import { camelizeKeys } from 'humps';
import { post } from '@namespace/helpers';

export const getABTestWithAdd = (deviceId, tests) =>
  post(`/service/segmentation/v3/abtests/get`, {
    device_id: deviceId,
    add_to: tests
  }).then(camelizeKeys);
